import HighlightText from 'components/UI/Inputs/AIQAutocomplete/HighlightText';
import PropTypes from 'prop-types';
import styles from './AdditionalInfo.module.css';

function AdditionalInfo({ option, hasAlerts, searchTerm }) {
    const isDuplicate = option.duplicate;
    const {
        identificationNumber = '',
        dateOfBirth = '',
        position = '',
        companyCardNumber = '',
        company = { fullName: '' },
        cdl = '',
        address = '',
        industryType = '',
        relationType = '',
    } = option;

    if (!hasAlerts && !isDuplicate) {
        return null;
    }

    return (
        <div className={styles['meta-row']}>
            {industryType && (
                <div className={styles['meta-item']}>
                    <span className={styles.label}>Industry Type:</span>{' '}
                    <span className={styles.val}>
                        <HighlightText text={industryType} searchTerm={searchTerm} />
                    </span>
                </div>
            )}
            {relationType && (
                <div className={styles['meta-item']}>
                    <span className={styles.label}>Relation Type:</span>{' '}
                    <span className={styles.val}>
                        <HighlightText text={relationType} searchTerm={searchTerm} />
                    </span>
                </div>
            )}
            {position && (
                <div className={styles['meta-item']}>
                    <span className={styles.label}>Title:</span>{' '}
                    <span className={styles.val}>
                        <HighlightText text={position} searchTerm={searchTerm} />
                    </span>
                </div>
            )}
            {dateOfBirth && (
                <div className={styles['meta-item']}>
                    <span className={styles.label}>D.o.B:</span>{' '}
                    <span className={styles.val}>
                        <HighlightText text={dateOfBirth} searchTerm={searchTerm} />
                    </span>
                </div>
            )}
            {address && (
                <div className={styles['meta-item']}>
                    <span className={styles.label}>Address:</span>{' '}
                    <span className={styles.val}>
                        <HighlightText text={address} searchTerm={searchTerm} />
                    </span>
                </div>
            )}
            {identificationNumber && (
                <div className={styles['meta-item']}>
                    <span className={styles.label}>DL:</span>{' '}
                    <span className={styles.val}>
                        <HighlightText text={identificationNumber} searchTerm={searchTerm} />
                    </span>
                </div>
            )}
            {cdl && (
                <div className={styles['meta-item']}>
                    <span className={styles.label}>CDL:</span>{' '}
                    <span className={styles.val}>
                        <HighlightText text={cdl} searchTerm={searchTerm} />
                    </span>
                </div>
            )}
            {companyCardNumber && (
                <div className={styles['meta-item']}>
                    <span className={styles.label}>Company Card #:</span>{' '}
                    <span className={styles.val}>
                        <HighlightText text={companyCardNumber} searchTerm={searchTerm} />
                    </span>
                </div>
            )}
            {company?.fullName && (
                <div className={styles['meta-item']}>
                    <span className={styles.label}>Organization:</span>{' '}
                    <span className={styles.val}>
                        <HighlightText text={company.fullName} searchTerm={searchTerm} />
                    </span>
                </div>
            )}
        </div>
    );
}

export default AdditionalInfo;

AdditionalInfo.propTypes = {
    option: PropTypes.shape({
        duplicate: PropTypes.number,
        id: PropTypes.number,
        identificationNumber: PropTypes.string,
        identificationType: PropTypes.string,
        dateOfBirth: PropTypes.string,
        position: PropTypes.string,
        companyCardNumber: PropTypes.string,
        company: PropTypes.shape({
            fullName: PropTypes.string,
        }),
        cdl: PropTypes.string,
        address: PropTypes.string,
        industryType: PropTypes.string,
        relationType: PropTypes.string,
    }),
    hasAlerts: PropTypes.bool,
    searchTerm: PropTypes.string,
};
